import { GoogleIcon, ICON_ID, ICON_SIZES } from "../components/icons/google-icon";
import { ApplicationApprovalStatus } from "../models/order/application-approval-status";

export function generateStatusIcon(status: ApplicationApprovalStatus) {
    switch (status) {
        case ApplicationApprovalStatus.AwaitingApproval:
            return (
                <GoogleIcon
                    tooltip="Awaiting approval"
                    id={ICON_ID.Error}
                    isWarning
                    size={ICON_SIZES.Large}
                />
            );

        case ApplicationApprovalStatus.Rejected:
            return (
                <GoogleIcon
                    tooltip="Rejected"
                    id={ICON_ID.Close} // Use appropriate icon for rejected
                    isDanger
                    size={ICON_SIZES.Large}
                />
            );

        case ApplicationApprovalStatus.Approved:
        default:
            return (
                <GoogleIcon
                    tooltip="Approved"
                    id={ICON_ID.CheckCircle}
                    isSuccess
                    size={ICON_SIZES.Large}
                />
            );
    }
}
